module.exports = __webpack_public_path__ + "static/media/veraz.9bbb766a.png";